import React from 'react';
import { FormattedMessage } from 'react-intl';
import reduxStore from './../../../reduxStore';
import { findIndex } from 'lodash';

export default class PreviewPagination extends React.Component {

    constructor(props) {
        super(props);
        this.getCurrentCompanyPosition = this.getCurrentCompanyPosition.bind(this);

        this.state = {
            firstNumber: 1,
            secondNumber: props.previewEntitiesCount
        };

    }

    componentWillReceiveProps(nextProps) {

        let companyPosition = this.getCurrentCompanyPosition();

        let firstNumber = companyPosition > 0 ? companyPosition : 1;

        let secondNumberProps = nextProps.previewEntitiesCount;

        this.setState({
            firstNumber: firstNumber,
            secondNumber: secondNumberProps
        });

    }

    getCurrentCompanyPosition() {
        let previewItems = reduxStore.getState().reviewCompanies.previewItems;
        let currentCompany = this.props.currentCompany;
        return findIndex(previewItems, (previewItem) => previewItem.id === currentCompany) + 1;
    }

    render() {

        let previousButtonClasses = this.props.previousCompanyId ? 'button-previous__square la-TriangleLeft' :
                'button-previous__square la-TriangleLeft disabled',
            nextButtonClasses     = this.props.nextCompanyId ? 'button-next__square la-TriangleRight' :
                'button-next__square la-TriangleRight disabled',
            previousLinkUrl       = this.props.previousCompanyId ?
                '/#/preview-company/' + this.props.previousCompanyId :
                null,
            nextLinkUrl           = this.props.nextCompanyId ? '/#/preview-company/' + this.props.nextCompanyId : null;

        //in edit third party, the page counter should not be displayed
        if (this.props.route == 'edit-third-party') {
            return null;
        }

        return (

            <div className="preview-company-details__pagination-container notranslate no-print">

                <div className="button-previous">
                    <a href={previousLinkUrl} className={previousButtonClasses}></a>
                </div>

                <span className="counter">
                    <span>{this.state.firstNumber}</span>
                    &nbsp;
                    <FormattedMessage id="Entities_Preview_UIText_previewCompanies.resultsPagination.of" />
                    &nbsp;
                    <span>{this.state.secondNumber}</span>
                    &nbsp;
                    <FormattedMessage id="Entities_Preview_UIText_previewCompanies.resultsPagination.entities" />
                </span>

                <div className="button-next">
                    <a href={nextLinkUrl} className={nextButtonClasses}></a>
                </div>

            </div>

        );
    }

}


// WEBPACK FOOTER //
// ./src/scripts/pages/PreviewCompany/template/PreviewCompany.previewPagination.jsx